/* eslint-disable no-unused-vars */
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useTheme } from '../../../theme';

export default function ThemeToggle({ isMobile = false }) {
  const { theme, toggleTheme } = useTheme(); // eslint-disable-line no-unused-vars
  const isDark = theme === 'dark'; // eslint-disable-line no-unused-vars

  // NOTE: Theme toggle is hidden while light mode is hardcoded (see theme/ThemeContext.jsx).
  // To bring the button back, remove `return null;` and uncomment the JSX below.
  return null;

  // return (
  //   <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
  //     <IconButton
  //       onClick={toggleTheme}
  //       aria-label={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
  //       sx={{
  //         color: isDark ? '#00DCBC' : '#64748b',
  //         border: '1px solid var(--bv-border)',
  //         borderRadius: '12px',
  //         p: isMobile ? { xs: 0.7, sm: 0.9 } : 0.8,
  //         bgcolor: 'var(--bv-surface)',
  //         transition: 'all 0.2s ease',
  //         '&:hover': {
  //           bgcolor: 'var(--bv-surface-2)',
  //           color: isDark ? '#00DCBC' : '#02B096',
  //           borderColor: '#00DCBC',
  //         },
  //       }}
  //     >
  //       {isDark ? (
  //         <LightModeIcon sx={{ fontSize: isMobile ? { xs: 20, sm: 22 } : 20 }} />
  //       ) : (
  //         <DarkModeIcon sx={{ fontSize: isMobile ? { xs: 20, sm: 22 } : 20 }} />
  //       )}
  //     </IconButton>
  //   </Tooltip>
  // );
}
